import React, { createContext, PropsWithChildren, useState } from 'react';
import QuestionSavingStatusViewModel from '../Monitoring/ViewModels/QuestionSavingStatusViewModel';

type ContextModel = {
    questionsSavedStatus: QuestionSavingStatusViewModel[]
    setQuestionSavedStatus: (value: QuestionSavingStatusViewModel[]) => void;
    updateSavedStatus: (question: QuestionSavingStatusViewModel) => void;
    areAllQuestionsSaved: () => boolean;
    areAnyQuestionsSaving: () => boolean;
};

export const ScorecardContext = createContext<ContextModel>({
    questionsSavedStatus: [],
    setQuestionSavedStatus: () => { throw new Error('Cannot use context without provider') },
    updateSavedStatus: () => { throw new Error('Cannot use context without provider') },
    areAllQuestionsSaved: () => { throw new Error('Cannot use context without provider') },
    areAnyQuestionsSaving: () => { throw new Error('Cannot use context without provider') }
});

export default function ScorecardProvider({ children }: PropsWithChildren<{}>) {
    const [questionsSavedStatus, setQuestionSavedStatus] = useState<QuestionSavingStatusViewModel[]>([]);

    const updateSavedStatus = (questionToUpdate: QuestionSavingStatusViewModel) => {
        setQuestionSavedStatus((prevState) => {
            const existingIndex = prevState.findIndex(question => question.id === questionToUpdate.id)

            if (existingIndex === -1) {
                return [...prevState, questionToUpdate]
            }

            return prevState.map((state) =>
                state.id === questionToUpdate.id ? { ...state, ...questionToUpdate } : state)
        })
    }

    const areAllQuestionsSaved = () => {
        return questionsSavedStatus.every(e => e.isSaved)
    }

    const areAnyQuestionsSaving = () => {
        return !questionsSavedStatus.every(e => !e.isSaving)
    }

    const context: ContextModel = {
        questionsSavedStatus,
        setQuestionSavedStatus,
        updateSavedStatus,
        areAllQuestionsSaved,
        areAnyQuestionsSaving
    }

    return (
        <ScorecardContext.Provider value={context}>
            {children}
        </ScorecardContext.Provider>
    )
}